import { z } from "zod";

export const GetTextSuggestionsRequestBodySchema = z.object({
  inputText: z.string(),
});

export type GetTextSuggestionsRequestBodyType = z.infer<
  typeof GetTextSuggestionsRequestBodySchema
>;

export const GetTextSuggestionsResponseBodySchema = z.object({
  suggestions: z.string().array(),
});

export type GetTextSuggestionsResponseBodyType = z.infer<
  typeof GetTextSuggestionsResponseBodySchema
>;
